import { createContext, useContext, useEffect } from "react";

export interface iPageCrumb {
	/** The item's own name, e.g. the event's name. */
	label: string;
	/** The list the item belongs to — its crumb comes before the item's. */
	parentHref?: string;
	parentLabel?: string;
}

/**
 * The header breadcrumb's crumbs for a detail page. Provided by DashboardLayout; pages set it with `usePageCrumb`.
 */
export const PageCrumbContext = createContext<(crumb: iPageCrumb | null) => void>(() => undefined);

/** Names the current page (and its list) in the header breadcrumb while it is mounted. */
export const usePageCrumb = (label?: string | null, parentHref?: string, parentLabel?: string) => {
	const setCrumb = useContext(PageCrumbContext);
	useEffect(() => {
		setCrumb(label ? { label, parentHref, parentLabel } : null);
		return () => setCrumb(null);
	}, [label, parentHref, parentLabel, setCrumb]);
};
